<template>

  <div class="movie-index">

    <div class="movie-bn">
      <img src="../../assets/img/bn2.jpg">
    </div>

    <div class="search-word">
      <button @click="toNovelSearch" class="s" style="width: 100%;"><span>搜索小说</span></button>
    </div>


    <!-- 导航 -->
    <div class="hd-nav">
        <ul>
          <li class="i9" @click="toNew">最新更新</li>
          <li class="i10" @click="toCategory">小说分类</li>
          <li class="i8" @click="toRecent">我的书架</li>
          <li v-if="inAndroidBrowser" class="i3" @click="downloadAndroidApp">APP</li>
          <li v-if="inIosBrowser" class="i3" @click="showIosFixDesktopStep=true">APP</li>
          <li class="i5"  @click="toNovelSearch">搜小说</li>
        </ul>
      </div>

    <div class="home-ls" >
        <div class="aui-book-head">
          <h2>今日更新</h2>
          <div class="r">
            <a class="ccc" @click="changeCategory(selected.category)">换一批</a>
            <span @click="toNew" class="more">更多</span>
          </div>
        </div>
        <ul class="ul">
          <li v-for="(item, index) in categoryList" :key="item.id" :class="{ active: getCategoryActive === item.id }"
                @click="changeCategory(item.id,0)">{{ item.name }}</li>
        </ul>

        <div class="aui-list-theme">
          <router-link :to="{name: 'novel-home', params: {id: book.bookId}}" v-for="book in updateBooks"
                       :key="book.bookId" class="aui-list-theme-item">
            <div class="aui-list-img">
              <img imgtype="novel" :bookid="book.bookId" :booktitle="book.title" :chapternum="0" :imgpath="book.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')" alt/>
            </div>
            <div class="aui-list-title">
              <h3>{{ book.title }}</h3>
              <div class="aui-flex">
                <div class="aui-flex-box">
                  <span class="i-a">{{ book.categoryName }}</span>
                  <span v-if="book.publishStatus==='serialize'" class="i-r">连载中</span>
                  <span v-if="book.publishStatus==='finish'" class="i-b">已完结</span>
                </div>
              </div>
            </div>
          </router-link>
        </div>

        <div v-if="isLoading" class="home-loading"></div>
    </div>


    <template v-for="(item,index) in pageInfo.showcases">

      <template v-if="item.type == 'e_recommend'">
        <div class="divHeight" :key="index"></div>
        <books-normal
            :key="item.name"
            :title="item.name"
            :books="item.novelBooks"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('e_recommend', currentPage.recommendList);"
            @show-more="toCcXBTJ(item, item.name)"
          ></books-normal>
      </template>

      <template v-if="item.type == 'hot'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            :title="item.name"
            :books="item.novelBooks"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('hot', currentPage.hotList);"
            @show-more="toCcRQBD(item, item.name)"
          ></books-normal>
      </template>

        <template v-if="item.type == 'kkbg'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            :title="item.name"
            :books="item.novelBooks"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('kkbg', currentPage.kkbgList);"
            @show-more="toCcXSZB(item, item.name)"
          ></books-normal>
        </template>

        <template v-if="item.type == 'new_on'">
          <div class="divHeight" :key="index"></div>
          <books-small
            :key="item.name"
            :title="item.name"
            :books="item.novelBooks"
            :showRefresh="true"
            v-on:show-refresh="showRefresh('new_on', currentPage.newOnList);"
            @show-more="toCcXSSD(item, item.name)"
          ></books-small>
        </template>

      </template>



      <div v-show="isLoading" class="loadingBox">加载中</div>

      <novelBottom></novelBottom>

      <div class="download-pops" v-if="inAndroidBrowser && !inWebView" @click="downloadAndroidApp">
        <div class="tx">下载APP，每日领金币</div>
      </div>

  </div>


</template>

<script>
import { mapGetters } from 'vuex'
import novelBottom from '@/components/layer1/bottomIndex'
import BooksSmall from '@/components/novel/books-small'
import BooksLarge from '@/components/novel/books-large'
import BooksNormal from '@/components/share/books-normal'
import userService from "../../services/userService"
import novelService from '../../services/novelService'
import kkUtil from "../../assets/js/kk-util"
import shelfService from '../../services/shelfService'
import commService from "../../services/commService";

export default {
  name: "novel",
  data() {
    return {
      componentName: '',
      categoryList: [],
      selected: {
        category: '0',
        pageSize: 6,
        publish: 'all'
      },
      todayUpdateBooks:[],
      todayUpdateCurrentPage: 0,
      isLoading: false,
      isMainLoading: false,
      isNoMoreData: false,
      totalItem: 0,
      isLoading: false,
      userInfo: '',
      homeShelves: '',
      shelfPage: 0,
      homeDaily:[],
      showIosFixDesktopStep: false,
      inWebView: false,
      inAndroidBrowser: false,
      inIosBrowser: false,
      pageInfo: {
        showcases: [],
        recommendList: [],
        hotList: [],
        kkbgList: [],
        newOnList: [],
      },
      key:{
        recommendList: 100,
        hotList: 200,
        kkbgList: 300,
        newOnList: 400,
      },
      currentPage:{
        recommendList: 1,
        hotList: 1,
        kkbgList: 1,
        newOnList: 1,
      },
      historyList: [],
      updateBooks: [],
    }
  },

  components: {
    novelBottom: novelBottom,
    'books-small': BooksSmall,
    'books-large': BooksLarge,
    BooksNormal,
  },
  computed: {
    getCategoryActive() {
      return this.selected.category
    },
    ...mapGetters(['getBookSearch', 'getHomeData'])
  },
  methods: {
    //下载app
    downloadAndroidApp() {
        window.location.href = commService.getLocalInitData().appDownloadUrl2;
    },
    //搜索
    toNovelSearch() {
      this.$router.isBack = true;
      this.$router.push({name: 'novel-search'});
    },
    //书架
    toRecent () {
      this.$router.isBack = false
      this.$router.push({ name: 'novel-shelf', query: { active: 'history' } })
    },
    //每日更新 更多
    toNew () {
      this.$router.isBack = false
      this.$router.push({name: 'novel-new'});
      //this.$router.push('novel-new')
    },
    toCategory(){
      this.$router.isBack = false
      this.$router.push({name: 'novel-category'});
    },
    getIndexPage () {
      const { getHomeData } = this
      if (getHomeData) {
        this.pageInfo = getHomeData
        return
      }
      novelService
        .getIndexPage()
        .then(res => {
          const resData = res.data
          this.pageInfo = resData
          this.$store.commit('saveHomeData', resData)
          this.setHomeDataLocal(resData)
        })
        .catch(() => {
          this.$dialog.confirm({
            message: '网络超时，请刷新重试'
          }).then(() => {
            this.getIndexPage()
          })
        })
    },


    //获取分类
    getCategory() {
      novelService.getCategory().then(res => {
        this.categoryList = res.data.categoryList
      })
    },

    //换一批
    changeCategory(id,page) {
          this.selected.category = id;
          if(page === 0){
            this.todayUpdateCurrentPage = 0;
          }
          this.getCategoryBooks(this.selected.category);
    },

    //请求下一批
    getCategoryBooks(category) {
      this.todayUpdateCurrentPage += 1;
      if(this.todayUpdateCurrentPage > 3){
        this.todayUpdateCurrentPage = 1
      }
      this.isLoading = true;
      this.isNoMoreData = false;
      this.updateBooks = [];
      let _category = category
      if (category === 0) {
        _category = ''
      }
      novelService.getUpdateList(_category, this.selected.pageSize, this.todayUpdateCurrentPage, )
        .then(res => {
          this.isLoading = false;
          if (res.result) {
            if (res.data.totalPage === 0) {
              this.updateBooks = [];
            } else {
              this.updateBooks = res.data.novelBookList;
            }
            this.totalItem = res.data.totalItem;
          }
        })
    },

    //橱窗换一批
    showRefresh(type, page){
      this.isMainLoading = true
      let currentPage = page >= 3 ? 1 : page + 1
      novelService.getRefreshList(type, currentPage)
        .then(res => {
          if (res.code === 200) {

              switch (type) {
                case 'e_recommend':

                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'e_recommend'){
                      this.pageInfo.showcases[key].novelBooks = res.data.novelBookList
                    }
                  }
                  this.currentPage.recommendList = currentPage
                  this.key.recommendList += 1
                  break;
                case 'hot':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'hot'){
                      this.pageInfo.showcases[key].novelBooks = res.data.novelBookList
                    }
                  }
                  this.currentPage.hotList = currentPage
                  this.key.hotList += 1
                  break;
                case 'kkbg':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'kkbg'){
                      this.pageInfo.showcases[key].novelBooks = res.data.novelBookList
                    }
                  }
                  this.currentPage.kkbgList = currentPage
                  this.key.kkbgList += 1
                  break;
                case 'new_on':
                  for (let key in this.pageInfo.showcases) {
                    if(this.pageInfo.showcases[key].type === 'new_on'){
                      this.pageInfo.showcases[key].novelBooks = res.data.novelBookList
                    }
                  }
                  this.currentPage.newOnList = currentPage
                  this.key.newOnList += 1
                  break;
              }
            this.isMainLoading = false
          }else{
            this.isMainLoading = false
          }
        })
    },


    setHomeDataLocal (data = {}) {
      window.localStorage.setItem('$_home_data', JSON.stringify(data))
    },
    getHomeDataLocal () {
      try {
        let data = window.localStorage.getItem('$_home_data')
        if (data) {
          data = JSON.parse(data)
          this.pageInfo = data
        }
      } catch (error) {}
    },
    loadHistory () {
      this.historyList = shelfService
        .getHistory()
        .map(item => item.bookInfo)
        .splice(0, 3)
    },
      toCcXBTJ() {
        this.$router.isBack = false;
        this.$router.push({name: 'novel-xbtj'});
      },
      toCcRQBD() {
        this.$router.isBack = false;
        this.$router.push({name: 'novel-rqbd'});
      },
      toCcXSZB() {
        this.$router.isBack = false;
        this.$router.push({name: 'novel-xszb'});
      },
      toCcXSSD() {
        this.$router.isBack = false;
        this.$router.push({name: 'novel-xssd'});
      },


    getUpdateBooks () {
      novelService.getUpdateList('', 6, 1).then(res => {
        const resData = res.data
        this.updateBooks = resData.novelBookList || []
      })
    }

  },

  created () {
    this.inWebView = kkUtil.isInWebView();
    this.getHomeDataLocal()
    this.getCategory()
  },

  mounted() {
    this.userInfo = userService.getLocalUserInfo();

    this.inAndroidBrowser = kkUtil.isInAndroidBrowser();
    this.inIosBrowser = kkUtil.isInIosBrowser();

    this.componentName = this.$route.name;
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
      setTimeout(() => {
        let scrollDiv = document.getElementById('scroll-div-category');
        //console.log(this.$store.state.pageState[this.$route.name].top);
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
      }, 0);
    } else {
      this.getIndexPage()
      this.getUpdateBooks()
      //this.loadHistory()
    }
    this.$router.isBack = true;
  },
}
</script>




<style scoped>

@import "../../assets/css/novel.css";

.movie-index{  padding: 10px 10px 60px 10px; background: #202125;}
.movie-bn{ border-radius: 10px; margin-bottom: 0px; overflow: hidden; padding: 0;}
.movie-bn img{ width: 100%;border-radius: 10px;  }


.movie-box{  border-radius: 10px; background: #fff; margin-bottom: 15px; }

.movie-box-flex{overflow-x: scroll; overflow-y: hidden; display: flex; flex-wrap: wrap; min-height: 8rem; }

.f-x{width: 74rem; height: 7.4rem;margin-left: .3rem; display: flex; flex-wrap: nowrap; margin: .2rem 0 .3rem 0;}
.movie-box .f-x .item{ width: 7rem;margin: 0.2rem 0.15rem; border:.12rem solid #fff980; border-radius: .4rem; overflow: hidden; position: relative;}
.movie-box .f-x .item a{ height: 5rem;}
.movie-box .f-x .ico{background: url(../../assets/images/i6.png) center center no-repeat; background-size: 100% auto; position: absolute; right: 0rem; top:0rem; width: 1.5rem; height: 1.5rem;}
.movie-box h3{padding: 0.2rem 0 0.3rem 0;height: 1rem; line-height: 1rem; border-bottom: 1px solid #EEE;}
.movie-box h3 span{padding-left: 35px; font-size: .7rem; color: #735100;font-weight: 500;
  background: url(../../assets/images/icon-h3-2.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-1{background: url(../../assets/images/icon-h3-3.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-2{background: url(../../assets/images/icon-h3-2.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-3{background: url(../../assets/images/icon-h3-1.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-4{background: url(../../assets/images/icon-h3-10.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-5{background: url(../../assets/images/icon-h3-4.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-6{background: url(../../assets/images/icon-h3-5.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-7{background: url(../../assets/images/icon-h3-9.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-8{background: url(../../assets/images/icon-h3-6.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-9{background: url(../../assets/images/icon-h3-8.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-10{background: url(../../assets/images/icon-h3-7.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 span.icon-h3-new{background: url(../../assets/images/i17.png) 8px center no-repeat; background-size: .9rem;}
.movie-box h3 i{ float: right; font-size: .5rem; margin-right: 8px; color: #fff; font-style: normal;  margin-top: 3px;}
.movie-box .item{ background: #fff; padding: 0 0 0 0; margin: 0.2rem 2%; width: 46%;box-sizing: content-box; border-radius: 5px;}
.movie-box .item a {
  background: #1a1a1a url(../../assets/img/loading_ho2.jpg) center center no-repeat; background-size:40px;
  position: relative;
  display: block;
  /* padding-top: 68%; */
  height: 6rem;
  border-radius: 4px;
  overflow: hidden;}
.movie-box .item a img{ width: 100%; height: 100%; vertical-align: middle; }
.movie-box .item h5{
  color: #333;
  font-size: .55rem;
  height: 1.4rem;
  line-height: .8rem; font-weight: 600;
  overflow: hidden;
  padding:.2rem;}
.movie-box-home{    background: linear-gradient(135deg, #006757 0%, #b8be00 100%);}
.movie-box-home h3{    border-bottom: 1px solid #58814f;}
.movie-box-home h3 span{color: #fff;}

.nav-on{ height: 1rem; line-height: 1rem; font-size: .5rem; text-align: center; color: #fb4447;
  width: 5rem; margin: 0 auto 0 auto; border-radius: 5px; border: 1px solid #fb4447; margin-bottom: 5px;}
.search-word{ margin-bottom: 8px !important;}
.loadingBox{ position: fixed; top: calc(50% - 40px); left: calc(50% - 40px); width: 80px; height: 80px; line-height: 140px; overflow: hidden;
  background: #000 url(../../assets/img/loading.gif) center -20px no-repeat; background-size:110px ; color: #ccc; text-align: center; font-size: 12px; border-radius: 10px;}

  .movie-box i{line-height:1rem;  width: 2.6rem;font-size: .5rem;color: #fff;font-weight: 500;text-align: center; margin-right:0.5rem;
  border-radius: 0.5rem;background:#65655d;color: #fff; font-weight: 400;}
  .movie-box i.refresh{background:#65655d url(../../assets/images/i7.png) 0.4rem center no-repeat; background-size: 0.5rem; padding-left: 0.6rem; }

  .movie-box-flex .item a .vip-free{ position: absolute; top: 0.05rem; left:0.05rem; width: 2.5rem; height: 1.2rem;
  background:  url(../../assets/images/i18.png)left center no-repeat; background-size:auto 100%;}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/novel.vue